import { createPolicyItemConfigurationResolver } from '../../../model/policy-item-configuration.ts'
import type { PolicyItems } from '../../../model/policy-item.ts'
import { nlAovqlInflationIndexationRates } from '../nl-aovql-cover-configuration.ts'
import type { NlAovqlPolicyItem, NlAovqlPolicyItemsState } from '../nl-aovql-insurance.ts'

export const nlAovqlPolicyItemsV1_0_0 = {
  mentalDisorders: {
    name: 'mentalDisorders',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: { type: 'none' },
    possibleDeductibles: { type: 'not-applicable' },
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: false,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: false,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
    dependsOn: [],
  },
  inflationIndexation: {
    name: 'inflationIndexation',
    type: 'service',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'percentages',
      percentages: [...nlAovqlInflationIndexationRates],
      baseText: '',
    },
    possibleDeductibles: { type: 'not-applicable' },
    // The funnel offers the default rate only, the back office may pick another one from the list.
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: false,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
    dependsOn: [],
  },
} as const satisfies PolicyItems<NlAovqlPolicyItem, NlAovqlPolicyItemsState>
